// Contracts — kids PARENT cabinet (2026-06-28). The parent's own home view:
// their children + their meetings (booking) + the per-child shoot status. Read-only.
// Shapes snapped from migrations/0002 (children, meetings, sessions).
import { z } from 'zod';

// Per-child status, derived from the child's latest non-canceled session:
//  booked   — child has no session yet (just a meeting)
//  started  — a session is in progress
//  done     — shot finished
//  packed   — session.packed = 1
//  canceled — latest session canceled (no live session)
export const KidsParentChildStatusSchema = z.enum([
  'booked',
  'started',
  'done',
  'packed',
  'canceled',
]);
export type KidsParentChildStatus = z.infer<typeof KidsParentChildStatusSchema>;

export const KidsParentChildSchema = z.object({
  id: z.string(),
  name: z.string(),
  age: z.number().int().nullable(),
  gender: z.string().nullable(),
  meetingId: z.string().nullable(),
  scheduledTime: z.string().nullable(),
  status: KidsParentChildStatusSchema,
});
export type KidsParentChild = z.infer<typeof KidsParentChildSchema>;

export const KidsParentMeetingSchema = z.object({
  id: z.string(),
  office: z.string(),
  date: z.string(),
  time: z.string(),
  status: z.string(),
});
export type KidsParentMeeting = z.infer<typeof KidsParentMeetingSchema>;

// GET /api/kids/me/home (Bearer parent) → own children + meetings + statuses.
export const KidsParentHomeResSchema = z.object({
  children: z.array(KidsParentChildSchema),
  meetings: z.array(KidsParentMeetingSchema),
});
export type KidsParentHomeRes = z.infer<typeof KidsParentHomeResSchema>;
